import React, { useState, useEffect } from "react"

import Layout from "../components/layout/layout"
import Seo from "../components/seo/seo"
import Hero from "../components/hero/hero"
import Introduction from "../components/introduction/introduction"
import About from "../components/about/about"
import Modal from "../components/modal/modal"
import Signup from "../components/signup/signup"
import Newsletter from "../components/newsletter/newsletter"

const Home = () => {

  const [showModal, setShowModal] = useState(true)

  const handleOpenModal = () => {
    setShowModal(prev => !prev)
  }

  useEffect(() => {}, [showModal])
  return (
    <Layout>
      <Seo title="Home" />
      <Hero />
      <Introduction />
      <About />
      <Signup handleClick={handleOpenModal}/>
      <Newsletter />
      <Modal showModal={showModal} setShowModal={setShowModal} />
    </Layout>
  )
}

export default Home